<template>
  <div id="shell">
    <ConfirmDialog></ConfirmDialog>
    <Toast
      :pt="{
        icon: ({ props: toastProps }) => ({
          
          class: [
            {
              'is-warn': toastProps.message?.severity === 'warn',
              'is-info': toastProps.message?.severity === 'info',
              'is-success': toastProps.message?.severity === 'success',
              'is-error': toastProps.message?.severity === 'error',
              
            },
          ],
         
        }),
      }"
    >
      <template #icon="{ class: className }">
      <svg :class="className" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.9999 20.1667C13.5312 20.1667 15.8229 19.1406 17.4817 17.4818C19.1406 15.8229 20.1666 13.5313 20.1666 11C20.1666 8.46872 19.1406 6.17705 17.4817 4.51818C15.8229 2.85935 13.5312 1.83333 10.9999 1.83333C8.46864 1.83333 6.17697 2.85935 4.5181 4.51818C2.85927 6.17705 1.83325 8.46872 1.83325 11C1.83325 13.5313 2.85927 15.8229 4.5181 17.4818C6.17697 19.1406 8.46864 20.1667 10.9999 20.1667Z" :stroke="getColor(className)" stroke-width="1.5" stroke-linejoin="round"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0001 16.9583C11.6329 16.9583 12.1459 16.4453 12.1459 15.8125C12.1459 15.1797 11.6329 14.6667 11.0001 14.6667C10.3673 14.6667 9.85425 15.1797 9.85425 15.8125C9.85425 16.4453 10.3673 16.9583 11.0001 16.9583Z" :fill="getColor(className)"/>
      <path d="M11 5.5V12.8333" :stroke="getColor(className)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      </template>
    </Toast>  
    <router-view></router-view>
  </div>
</template>
<script>
import { onMounted, onBeforeUnmount } from 'vue';
import {useLayoutStore} from "@shared/stores/layout.store";
export default {
  methods:{
    getColor(cls){
      for(var x in this.colorMap){
         if(cls.search(x) > -1){
            return this.colorMap[x];
         }
      }
      return '#000000';
    }
  },
  data() {
    return {
      colorMap: {
        'is-success': '#00995C', 
        'is-warn': '#C99300',  
        'is-error': '#E54040 ',   
        'is-info': '#0086BF'     
      }
    };
  },
  computed: {
    getLoading(){
      return this.layoutStore.getLoading;
    }  
    },
  watch: {
    getLoading: {
      deep: true, // Theo dõi sâu các thay đổi trong getLoading
      handler(newLoadingState) {
        Object.keys(newLoadingState).forEach(key => {
          const isLoading = newLoadingState[key];
         
          if(key=='root'){
              if(isLoading)
                  document.body.classList.add('loading');
              else
                  document.body.classList.remove('loading');  
          }else{
              let elms = document.querySelectorAll('[data-load="'+key+'"]');
              if(elms.length > 0){
                  if(isLoading)
                      elms[0].classList.add('loading');
                  else
                      elms[0].classList.remove('loading');  
              }

          }

          

        })
  
      }
    }
  },
  setup() {
    onMounted(() => {
    });
    onBeforeUnmount(() => {
    });
    return {layoutStore:new useLayoutStore()}

  },
};
</script>

<style lang="scss" scoped>
html.nprogress-busy{
  #shell{
    >p {
      width: 100%;
      height: 100vh;
      background: #e4edff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>